import $ from 'jquery'
import manager from '../manager'
import moment from 'moment'
import { INTERFACE } from '@/utils/INTERFACE'
import http from '@/utils/http'
import {formatTime} from '@/lib/utool'

function setDate(dom,now,to){
	var duration=moment.duration(to>now?(to-now):0)
	if(!duration.days()&&duration.days()!==0){
		$(dom).find(".day").text('--')
	}else{
		$(dom).find(".day").text(Math.floor(duration.asDays()))
	}
	if(!duration.hours()&&duration.hours()!==0){
		$(dom).find(".hour").text('--')
	}else{
		$(dom).find(".hour").text(duration.hours())
	}
	if(!duration.minutes()&&duration.minutes()!==0){
		$(dom).find(".minute").text('--')
	}else{
		$(dom).find(".minute").text(duration.minutes())
	}
	if(!duration.seconds()&&duration.seconds()!==0){
		$(dom).find(".second").text('--')
	}else{
		$(dom).find(".second").text(duration.seconds())
	}
}

async function fetchTimeDiff(){
	var pre=Date.now()
	var res=await http.jsonp.get(INTERFACE().now)
	var diff=res.nowSystemTime-pre-100
	return diff
}

var sysTimeDiff=0

manager.add('countdown',{
	created(to){
		setDate(this.dom,Date.now()+sysTimeDiff,to)
		this.timer=setInterval(()=>{
			setDate(this.dom,Date.now()+sysTimeDiff,to)
		},1000)
		if(sysTimeDiff)return
		fetchTimeDiff().then(data=>{
			sysTimeDiff=data
			setDate(this.dom,Date.now()+sysTimeDiff,to)
		})
	},
	destroyed(){
		clearInterval(this.timer)
	}
})

manager.add('formatTime',{
	created(time,format){
		$(this.dom).text(formatTime(time,format))
	}
})